<template name="radioSelect">
  <div class="radio-select-wrapper">
    <div class="row" v-for="(item, idx) in dataList" :key="idx">
        <div class="col-9">{{ item[propName] }}</div>
        <div class="col-3 switch">
            <input type="radio" :name="`${idScopeName}-radio-item`"
            :value="item.id" :id="`${idScopeName}-${item.id}`"
            :checked="item.checked" @change="handleChange"
            :disabled="isDisabled"
            >
            <label :for="`${idScopeName}-${item.id}`"></label>
        </div>
    </div>
  </div>
</template>
<!--
  Basic usage example:
  1. dataList is the array contains radio items,
  2. propName is the prop for item name, e.g.'userName', 'lessonName'
  3. idScopeName is a string to prevent duplicated ids on same page
  <radioSelect :dataList="postList" :propName="propName" :idScopeName="idScopeName"></radioSelect>
-->

<script type="text/javascript">
export default {
  name: 'radioSelect',
  props: {
    dataList: Array,
    propName: String,
    idScopeName: String,
    isDisabled: Boolean,
    isH5System: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
    handleChange(event) {
      if (this.$props.isH5System) {
        this.$emit('input', event.target.value);
        // quite strange, bind v-model on customized component does not work on wechat iPad
      } else {
        this.$emit('radioSelect', parseInt(event.target.value, 10));
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .radio-select-wrapper {
    .row {
      margin: auto;
      margin-bottom: 10px;
      .col-9 {
        padding-left: 0;
        color: #4a4a4a;
        font-size: 14px;
      }
      .col-3 {
        input {
          display: none;
          &:checked + label {
            &:before {
              background: transparent;
              border-color: #e42029;
            }
            &:after {
              right: 5px;
              opacity: 1;
            }
          }
        }
        label {
          height: 18px;
          width: 18px;
          cursor: pointer;
          &:before, &:after {
            content: '';
            position: absolute;
            display: block;
            -webkit-transition: all ease .3s;
            transition: all ease .3s;
          }
          &:before {
            border: 2px solid #dadada;
            border-radius: 9px;
            width: 18px;
            height: 18px;
            background: transparent;
            top: 0;
            right: 0;
          }
          &:after {
            background: #e42029;
            border-radius: 4px;
            width: 8px;
            height: 8px;
            display: block;
            top: 5px;
            right: 5px;
            opacity: 0;
          }
        }
      }
    }
  }
</style>
